import gql from 'graphql-tag';

export const GQL_VALID_LICENSE_CHECK = gql`
	query validLicenseCheck {
		validLicenseCheck {
			hasValidLicense
		}
	}
`;
